import Vue from 'vue';
import App from './App.vue';
import 'view-design/dist/styles/iview.css';
import './assets/css/style.scss';

import router from './router';
import options from './options';
import VueResource from 'vue-resource';
import VueProgressBar from 'vue-progressbar';
import progressBarInfo from './assets/js/progress-bar-info';
import ViewUI from 'view-design';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { initialAuth } from 'sgm-dms-vue-menu';

import store from './store';
initialAuth(options);

Vue.use(VueProgressBar, progressBarInfo);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(ViewUI);
Vue.directive('preventReClick', {
    inserted (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 3000);
            }
        });
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
